/**
 * Compares two arrays checking items with strict compare "===". Order matters.
 *
 * Useful for efficient comparing arrays of parts of store
 *
 * @example
 * distinctUntilChanged(isArrayEqualShallow, state => [
 *	 state.betslip,
 *	 state.selection
 * ])
 *  // _.isEqual() would do deep comparison of 'betslip' and 'selection' while reference check is enough
 *
 */
export function isArrayEqualShallow(a: any[], b: any[]): boolean {
	if (a === b) {
		return true;
	}

	if (!a || !b) {
		return false;
	}

	if (a.length !== b.length) {
		return false;
	}

	for (let i = 0; i < a.length; i++) {
		if (a[i] !== b[i]) {
			return false;
		}
	}

	return true;
}

export function isEqual(a: any, b: any): boolean {
	return JSON.stringify(a) === JSON.stringify(b);
}
